module.exports = __webpack_public_path__ + "img/Attitüde.b5dc3ffc.svg";